import type { SVGProps } from "react";

export const ArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    width={16}
    height={16}
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.44 18.555a1.493 1.493 0 01-1.06.445h-.76a1.533 1.533 0 01-1.06-.445L.296 8.168a1.016 1.016 0 010-1.434l1.42-1.435a.976.976 0 011.4 0L12 14.29 20.883 5.3a.995.995 0 011.42 0l1.401 1.435a1.015 1.015 0 010 1.434L13.44 18.555z"
    ></path>
  </svg>
);
